import React, { useEffect, useState } from 'react';
import { FiChevronDown, FiChevronUp, FiMail, FiPhone, FiSearch, FiHelpCircle, FiMap, FiPackage, FiRefreshCw, FiShield } from 'react-icons/fi';
import Navbar from '../homepage/Navbar';
import {Header} from '../../shared';
import {Footer} from "../../shared";

const FAQPage = () => {
  const [activeSection, setActiveSection] = useState(0);
  const [activeQuestions, setActiveQuestions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  useEffect(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);
  const toggleSection = (index) => {
    setActiveSection(index);
    setActiveQuestions([]);
  };

  const toggleQuestion = (index) => {
    setActiveQuestions(prev =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };

  // Filter FAQs based on search term
  const filteredFaqs = faqs.map(section => ({
    ...section,
    items: section.items.filter(item =>
      item.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.answer.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(section => section.items.length > 0);

  // Get icon for each section
  const getSectionIcon = (title) => {
    switch(title) {
      case 'General FAQs': return <FiHelpCircle className="w-5 h-5" />;
      case 'Flight Checker Zone FAQs': return <FiMap className="w-5 h-5" />;
      case 'Orders & Shipping FAQs': return <FiPackage className="w-5 h-5" />;
      case 'Returns & Exchanges FAQs': return <FiRefreshCw className="w-5 h-5" />;
      case 'Support & Legal FAQs': return <FiShield className="w-5 h-5" />;
      default: return <FiHelpCircle className="w-5 h-5" />;
    }
  };

  return (
    <>
     < Header />
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-700 py-16 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            How can we help?
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8">
            Find answers to common questions about drones, orders, and regulations
          </p>
          
          {/* Search bar */}
        <div className="max-w-2xl mx-auto relative">
  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
    <FiSearch className={`h-4 w-4 ${isSearchFocused ? 'text-blue-500' : 'text-gray-400'}`} />
  </div>
  <input
    type="text"
    placeholder="Search FAQs..."
    className="block w-full pl-10 pr-4 py-2 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-30 transition-all duration-200 text-base"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    onFocus={() => setIsSearchFocused(true)}
    onBlur={() => setIsSearchFocused(false)}
  />
  {searchTerm && (
    <button 
      onClick={() => setSearchTerm('')}
      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
      </svg>
    </button>
  )}
</div>

        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 -mt-12">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar navigation */}
         <div className="lg:w-1/3">
  <div className="sticky top-8">
    <div className="bg-white rounded-lg shadow-md p-4 mb-6">
      <h2 className="text-base font-semibold text-gray-900 mb-4 flex items-center">
        <svg className="w-4 h-4 mr-2 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
        </svg>
        FAQ Categories
      </h2>

      <nav className="space-y-2">
        {faqs.map((section, idx) => (
          <button
            key={idx}
            onClick={() => toggleSection(idx)}
            className={`w-full text-left px-4 py-2 rounded-lg transition-all flex items-center ${
              activeSection === idx
                ? 'bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 shadow-sm'
                : 'hover:bg-gray-50'
            }`}
          >
            <div className="w-8 h-8 rounded-md bg-blue-100 flex items-center justify-center mr-3 text-blue-600 text-sm">
              {getSectionIcon(section.title)}
            </div>
            <div className="text-left">
              <span className={`font-medium text-sm ${activeSection === idx ? 'text-blue-600' : 'text-gray-700'}`}>
                {section.title}
              </span>
              <div className="text-xs text-gray-500">{section.items.length} questions</div>
            </div>
          </button>
        ))}
      </nav>
    </div>

 <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-md shadow-md p-4 text-white relative text-sm">
  <div className="absolute -top-6 -right-6 w-16 h-16 bg-blue-500 rounded-full opacity-10"></div>
  <div className="absolute -bottom-6 -left-6 w-20 h-20 bg-indigo-500 rounded-full opacity-10"></div>

  <div className="relative z-10">
    <h3 className="font-semibold text-base mb-3">Need more help?</h3>
    <p className="text-sm text-white mb-4">
      Our support team is ready to assist you with any questions.
    </p>

    <div className="space-y-3">
      <a
        href="mailto:support@droneplanet.in"
        className="flex items-center bg-blue-100 text-blue-800 rounded-lg p-3 hover:bg-blue-200 transition-all"
      >
        <div className="p-2 bg-blue-200 rounded-lg mr-3">
          <FiMail className="h-5 w-5" />
        </div>
        <div>
          <div className="text-sm font-medium">Email us at</div>
          <div className="text-base font-semibold">support@droneplanet.in</div>
        </div>
      </a>

      <a
        href="tel:+919773571992"
        className="flex items-center bg-blue-100 text-blue-800 rounded-lg p-3 hover:bg-blue-200 transition-all"
      >
        <div className="p-2 bg-blue-200 rounded-lg mr-3">
          <FiPhone className="h-5 w-5" />
        </div>
        <div>
          <div className="text-sm font-medium">Call us at</div>
          <div className="text-base font-semibold">+91 97735 71992</div>
        </div>
      </a>
    </div>
  </div>
</div>

  </div>
</div>


          {/* FAQ content */}
        <div className="lg:w-2/3 mt-6">
  {filteredFaqs.length > 0 ? (
    filteredFaqs.map((section, idx) => (
      <div
        key={idx}
        className={`mb-8 bg-white rounded-xl shadow-md overflow-hidden ${
          activeSection !== idx && searchTerm === '' ? 'hidden' : ''
        }`}
      >
        {/* Section Header */}
      <div className="bg-gradient-to-r from-sky-100 to-blue-200 p-4  rounded-t-xl">
  <div className="flex items-center">
    <div className="w-10 h-10 rounded-md bg-blue-300 bg-opacity-30 flex items-center justify-center mr-3">
      {getSectionIcon(section.title)}
    </div>
    <h2 className="text-xl font-bold text-blue-900">{section.title}</h2>
  </div>
</div>


        {/* FAQ List */}
        <div className="p-4">
          {section.items.map((faq, index) => (
            <div
              key={index}
              className={`mb-3 rounded-lg overflow-hidden transition-all duration-300 ${
                activeQuestions.includes(index)
                  ? 'bg-blue-50 border border-blue-100'
                  : 'hover:bg-gray-50'
              }`}
            >
              <button
                onClick={() => toggleQuestion(index)}
                className="w-full text-left p-3 flex items-center justify-between focus:outline-none group"
              >
                <span
                  className={`font-medium text-base ${
                    activeQuestions.includes(index)
                      ? 'text-blue-600'
                      : 'text-gray-800 group-hover:text-blue-600'
                  } transition-colors`}
                >
                  {faq.question}
                </span>
                <div
                  className={`ml-4 w-7 h-7 rounded-full flex items-center justify-center text-sm ${
                    activeQuestions.includes(index)
                      ? 'bg-blue-100 text-blue-600'
                      : 'bg-gray-100 text-gray-500 group-hover:bg-blue-100 group-hover:text-blue-600'
                  } transition-colors`}
                >
                  {activeQuestions.includes(index) ? (
                    <FiChevronUp className="h-4 w-4" />
                  ) : (
                    <FiChevronDown className="h-4 w-4" />
                  )}
                </div>
              </button>
              <div
                className={`px-4 pb-4 transition-all duration-300 overflow-hidden ${
                  activeQuestions.includes(index)
                    ? 'max-h-96 opacity-100'
                    : 'max-h-0 opacity-0'
                }`}
              >
                <div className="pt-3 border-t border-gray-100 text-sm text-gray-700">
                  {faq.answer.split('\n').map((paragraph, i) => (
                    <p key={i} className="mb-3 last:mb-0">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    ))
  ) : (
    <div className="bg-white rounded-xl shadow-md p-8 text-center">
      <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-100 text-blue-600 mb-4">
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-2">No results found</h3>
      <p className="text-sm text-gray-600 max-w-md mx-auto mb-6">
        We couldn't find any FAQs matching "<strong>{searchTerm}</strong>". Try different keywords.
      </p>
      <button
        onClick={() => setSearchTerm('')}
        className="px-5 py-2.5 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-lg font-medium hover:opacity-90 transition-opacity shadow"
      >
        View All FAQs
      </button>
    </div>
  )}
</div>

        </div>
      </div>
    </div>
    < Footer />
    </>
  );
};

// FAQ data
const faqs = [
  {
    title: 'General FAQs',
    items: [
      {
        question: 'What types of drones do you sell?',
        answer: 'We offer a wide range of drones, including models for agriculture, photography, surveying, and nano drones. Each category features various models tailored to specific needs and applications.',
      },
      {
        question: 'How do I choose the right drone for me?',
        answer: 'Our drones are organized into clear categories based on their use cases. Use our comparison tool to evaluate different models side-by-side.',
      },
      {
        question: 'Are your drones beginner-friendly?',
        answer: 'Some of our models are designed with beginners in mind, but others are for professional use. Always check the specifications before purchasing.',
      },
      {
        question: 'Are replacement parts or accessories available?',
        answer: 'Yes, we offer a variety of replacement parts and accessories, including controllers, motors, propellers, and more.',
      },
    ],
  },
  {
    title: 'Flight Checker Zone FAQs',
    items: [
      {
        question: 'How do I know where I can legally fly my drone?',
        answer: 'Use our Flight Tracker Tool, which highlights permitted and restricted airspaces. It shows real-time green, yellow, and red zones.',
      },
      {
        question: 'What do the red, yellow, and green zones mean?',
        answer: `- Green Zone: Flying is permitted without special permissions.\n- Yellow Zone: Requires prior approval.\n- Red Zone: Strictly no-fly zone, e.g., airports, military areas.`,
      },
      {
        question: 'Are the rules the same across all Indian states?',
        answer: 'No. While DGCA sets the core rules, local authorities may have additional restrictions. Check both national and local guidelines.',
      },
      {
        question: 'How often is the flight zone map updated?',
        answer: 'The tool is regularly updated and based on the latest DGCA regulations.',
      },
    ],
  },
  {
    title: 'Orders & Shipping FAQs',
    items: [
      {
        question: 'How long does delivery take?',
        answer: 'Orders are processed within 2–3 business days. Delivery time depends on your location and chosen shipping method.',
      },
      {
        question: 'Can I track my order?',
        answer: 'Yes. After shipping, you’ll receive an email with your tracking number and a tracking link.',
      },
      {
        question: 'What if my drone arrives damaged?',
        answer: 'Contact the shipping carrier immediately to file a claim. Save all packaging and damaged items for claim purposes.',
      },
    ],
  },
  {
    title: 'Returns & Exchanges FAQs',
    items: [
      {
        question: 'What is your return policy?',
        answer: 'Items must be returned within 5 days, unused, in original packaging, and with proof of purchase.',
      },
      {
        question: 'How do I initiate a return?',
        answer: 'Email support@droneplanet.in with your order number and reason. If approved, you’ll get an RMA and shipping instructions.',
      },
      {
        question: 'When will I receive my refund?',
        answer: 'After the item is received and inspected, refunds take 7–10 business days. Shipping costs are not refundable.',
      },
      {
        question: 'Can I exchange a product?',
        answer: 'We only offer exchanges for defective or damaged items. Email us with details and your order number.',
      },
      {
        question: 'Who pays for return shipping?',
        answer: 'You pay unless the item is defective or damaged. If eligible, Drone Planet covers the return shipping.',
      },
    ],
  },
  {
    title: 'Support & Legal FAQs',
    items: [
      {
        question: 'Do I need a license to fly a drone in India?',
        answer: 'Nano drones (under 250g) don’t need a license. Larger drones may require registration and a Remote Pilot Certificate under DGCA rules.',
      },
      {
        question: 'How do I contact customer support?',
        answer: 'You can reach us at support@droneplanet.in or call +91 97735 71992.',
      },
    ],
  },
];

export default FAQPage;